import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { defaultRemoteConfig, FirebaseFlags } from 'src/app/data/networking/models/firebase/response/flags';

@Injectable({
  providedIn: 'root',
})
export class FirebaseRemoteConfigEvent {
  remoteConfigInitialstate: FirebaseFlags = defaultRemoteConfig;
  private remoteConfig = new BehaviorSubject(this.remoteConfigInitialstate);
  get = this.remoteConfig.asObservable();

  update(event: FirebaseFlags): void {
    this.remoteConfig.next(event);
  }
}
